export default __webpack_public_path__ + "static/media/chart_over.9ba70168.svg";